import React from 'react';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  useTheme,
  alpha
} from '@mui/material';

// Define column keys for sorting
export type SortKey = 'id' | 'name' | 'active' | 'createDate' | 'updateDate';

// Table Header Component
const ApiKeysTableHeader: React.FC<{
  sortBy: SortKey;
  sortDirection: 'asc' | 'desc';
  handleSort: (key: SortKey) => void;
}> = ({ sortBy, sortDirection, handleSort }) => {
  const theme = useTheme();

  const headerCellStyle = {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
    py: 1.5,
    borderBottom: `2px solid ${alpha(theme.palette.divider, 0.7)}`,
    backgroundColor: theme.palette.background.default,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04)
    }
  };

  const sortLabelSx = (key: SortKey) => ({
    '& .MuiTableSortLabel-icon': {
      color: sortBy === key ? `${theme.palette.primary.main} !important` : undefined
    }
  });

  return (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            ...headerCellStyle,
            display: { xs: 'none', md: 'table-cell' }
          }}
        >
          <TableSortLabel
            active={sortBy === 'id'}
            direction={sortBy === 'id' ? sortDirection : 'asc'}
            onClick={() => handleSort('id')}
            sx={sortLabelSx('id')}
          >
            ID
          </TableSortLabel>
        </TableCell>
        <TableCell sx={headerCellStyle}>
          <TableSortLabel
            active={sortBy === 'name'}
            direction={sortBy === 'name' ? sortDirection : 'asc'}
            onClick={() => handleSort('name')}
            sx={sortLabelSx('name')}
          >
            Name
          </TableSortLabel>
        </TableCell>
        <TableCell align="center" sx={headerCellStyle}>
          <TableSortLabel
            active={sortBy === 'active'}
            direction={sortBy === 'active' ? sortDirection : 'asc'}
            onClick={() => handleSort('active')}
            sx={sortLabelSx('active')}
          >
            Status
          </TableSortLabel>
        </TableCell>
        <TableCell sx={headerCellStyle}>
          <TableSortLabel
            active={sortBy === 'createDate'}
            direction={sortBy === 'createDate' ? sortDirection : 'asc'}
            onClick={() => handleSort('createDate')}
            sx={sortLabelSx('createDate')}
          >
            Created
          </TableSortLabel>
        </TableCell>
        <TableCell sx={headerCellStyle}>
          <TableSortLabel
            active={sortBy === 'updateDate'}
            direction={sortBy === 'updateDate' ? sortDirection : 'asc'}
            onClick={() => handleSort('updateDate')}
            sx={sortLabelSx('updateDate')}
          >
            Updated
          </TableSortLabel>
        </TableCell>
        <TableCell align="center" sx={headerCellStyle}>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default ApiKeysTableHeader;
